define('OnlyGiftCertificate.Header.MiniCartItemCell.View', [
    'Header.MiniCartItemCell.View',
    'underscore'
], function OnlyGiftCertificate(
    HeaderMiniCartItemCellView,
    _
) {
    'use strict';

    _.extend(HeaderMiniCartItemCellView.prototype, {
        getContext: _.wrap(HeaderMiniCartItemCellView.prototype.getContext, function getContextFn(fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            context.rateFormatted = this.model.get('amount_formatted');
            return context;
        })
    });
});
